<div *ngIf="item" class="flex-container-new card" (click)="onCardClick($event)">
    <div class="applicationlink-icon" style="max-height:80px"><img style="width: 50px; height: 50px;" [src]="getUrl('/application-logos/applicationlink-custom-arrow.png')"></div>
    <div class="companytitle">{{item.name}}</div>
</div>
